import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchLastUpdate } from '../services/updateService';
import { formatToLocalTime } from '../utils/dateHelper';

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [lastUpdate, setLastUpdate] = useState('Not Available');

  // Memoized update function to be called globally
  const refreshLastUpdate = useCallback(async () => {
    try {
      const updateData = await fetchLastUpdate();
      const formattedUpdate = updateData ? formatToLocalTime(updateData) : "Not Available";
      setLastUpdate(formattedUpdate);
    } catch (err) {
      console.error("Global Sync Error:", err);
    }
  }, []);

  // Polling mechanism: Update every 5 minutes
  useEffect(() => {
    refreshLastUpdate(); // Initial load
    const interval = setInterval(refreshLastUpdate, 300000); // 300,000ms = 5 mins
    return () => clearInterval(interval);
  }, [refreshLastUpdate]);

  return (
    <ReportContext.Provider value={{ lastUpdate, refreshLastUpdate }}>
      {children}
    </ReportContext.Provider>
  );
};

//export const useReports = () => useContext(ReportContext);